import Button from 'components/Button';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  h1 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 500;
  }
  p {
    text-align: center;
    margin-bottom: 3rem;
  }
`;

const NotFound: FC = () => {
  return (
    <Container>
      <h1>404 | Page introuvable</h1>
      <p>La page que vous recherchez n'existe pas ou a été supprimée.</p>
      <Link to="/">
        <Button color="primary" variant="filled">
          Retourner à l'accueil
        </Button>
      </Link>
    </Container>
  );
};

export default NotFound;
